import { Typography } from '@components/Typography';
import { useStats } from 'react-instantsearch';

export default function NumberOfHits(props) {
  const { nbHits } = useStats();

  return (
    <Typography tag="h2" size="text-xl">
      Showing {nbHits} {props?.resultsText || 'results'}
    </Typography>
  );
}
